module.exports = {
  ENV_HOST: {
    CL: 'https://dev.falabella.com',
    PE: 'https://dev.falabella.com.pe',
    CO: 'https://dev.falabella.com.co',
    AR: 'https://dev.falabella.com.ar',
  },
};
